import { createContext } from "react";

const BreadContext = createContext([{ page: "Home", path: "/" }]);

export default BreadContext;
